import SafetyAnchorPointListResourceModel from '../../generated/types/model/resource/SafetyAnchorPointListResourceModel';

export default class SafetyAnchorPointListResourceViewModel extends SafetyAnchorPointListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
